export default function Error() {

    return (
        <div className='map-error'>
            <div className='map-error-title'>Error retrieving your credentials</div>
            <div className='map-error-text'>Contact Space-Eyes (support@space-eyes.com) for assistance.</div>
            <div className='map-error-button'>Sign out</div>
        </div>
    )
}